import * as React from "react";
const SvgCropPortrait = (props) => /* @__PURE__ */ React.createElement("svg", { width: 10, height: 14, viewBox: "0 0 10 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("rect", { x: 0.5, y: 0.5, width: 9, height: 13, rx: 1.5, stroke: "currentColor" }));
export default SvgCropPortrait;
